import React, { useCallback } from 'react';

import ConfirmationDialog from '../../../common/ConfirmationDialog/ConfirmationDialog';
import ContactSupport from '../../../common/Labels/ContactSupportLink';
import Label from '../../../common/Labels/Label';

export const PipelineRemovalModal = ({
  error = null,
  pipeline = null,
  onPipelineRemoved = () => {},
  showDialog = false,
  onDialogToggle = () => {},
}) => {
  const onConfirm = useCallback(() => {
    onPipelineRemoved(pipeline?.name, pipeline?.workspace?.workspace_id);
  }, [onPipelineRemoved, pipeline])

  return (
    <ConfirmationDialog
      title="Delete Pipeline"
      confirmButtonText="Delete"
      confirmButtonType="danger"
      showDialog={showDialog}
      onDialogToggle={onDialogToggle}
      modalAnimationKey="delete-pipeline-modal"
      onConfirm={onConfirm}
      error={error}
    >
      <div className="w-small-modal p-2 m-1">
        <Label>
          The selected pipeline and all its versions will be deleted from Wallaroo. Are you sure?
        </Label>
        {
          error && (
            <div className="p-2">
              <Label color="error" size="sm">
                Error while deleting the pipeline. Please try again or <ContactSupport>contact support</ContactSupport> if the issue persists.
              </Label>
            </div>
          )
        }
      </div>
    </ConfirmationDialog>
  )
};

export default PipelineRemovalModal;
